export const countries = [
  { code: 'CA', en: 'Canada', fr: 'Canada' },
  { code: 'US', en: 'United States', fr: 'États-Unis' },
  { code: 'AF', en: 'Afghanistan', fr: 'Afghanistan' },
  { code: 'AL', en: 'Albania', fr: 'Albanie' },
  { code: 'DZ', en: 'Algeria', fr: 'Algérie' },
  { code: 'AS', en: 'American Samoa', fr: 'Samoa américaines' },
  { code: 'AD', en: 'Andorra', fr: 'Andorre' },
  { code: 'AO', en: 'Angola', fr: 'Angola' },
  { code: 'AI', en: 'Anguilla', fr: 'Anguilla' },
  { code: 'AQ', en: 'Antarctica', fr: 'Antarctique' },
  { code: 'AG', en: 'Antigua and Barbuda', fr: 'Antigua-et-Barbuda' },
  { code: 'AR', en: 'Argentina', fr: 'Argentine' },
  { code: 'AM', en: 'Armenia', fr: 'Arménie' },
  { code: 'AW', en: 'Aruba', fr: 'Aruba' },
  { code: 'AU', en: 'Australia', fr: 'Australie' },
  { code: 'AT', en: 'Austria', fr: 'Autriche' },
  { code: 'AZ', en: 'Azerbaijan', fr: 'Azerbaïdjan' },
  { code: 'BS', en: 'Bahamas', fr: 'Bahamas' },
  { code: 'BH', en: 'Bahrain', fr: 'Bahreïn' },
  { code: 'BD', en: 'Bangladesh', fr: 'Bangladesh' },
  { code: 'BB', en: 'Barbados', fr: 'Barbade' },
  { code: 'BY', en: 'Belarus', fr: 'Biélorussie' },
  { code: 'BE', en: 'Belgium', fr: 'Belgique' },
  { code: 'BZ', en: 'Belize', fr: 'Belize' },
  { code: 'BJ', en: 'Benin', fr: 'Bénin' },
  { code: 'BM', en: 'Bermuda', fr: 'Bermudes' },
  { code: 'BT', en: 'Bhutan', fr: 'Bhoutan' },
  { code: 'BO', en: 'Bolivia', fr: 'Bolivie' },
  { code: 'BA', en: 'Bosnia and Herzegovina', fr: 'Bosnie-Herzégovine' },
  { code: 'BW', en: 'Botswana', fr: 'Botswana' },
  { code: 'BR', en: 'Brazil', fr: 'Brésil' },
  { code: 'BN', en: 'Brunei Darussalam', fr: 'Brunéi Darussalam' },
  { code: 'BG', en: 'Bulgaria', fr: 'Bulgarie' },
  { code: 'BF', en: 'Burkina Faso', fr: 'Burkina Faso' },
  { code: 'BI', en: 'Burundi', fr: 'Burundi' },
  { code: 'KH', en: 'Cambodia', fr: 'Cambodge' },
  { code: 'CM', en: 'Cameroon', fr: 'Cameroun' },
  { code: 'CV', en: 'Cabo Verde', fr: 'Cap-Vert' },
  { code: 'CF', en: 'Central African Republic', fr: 'République centrafricaine' },
  { code: 'TD', en: 'Chad', fr: 'Tchad' },
  { code: 'CL', en: 'Chile', fr: 'Chili' },
  { code: 'CN', en: 'China', fr: 'Chine' },
  { code: 'CO', en: 'Colombia', fr: 'Colombie' },
  { code: 'KM', en: 'Comoros', fr: 'Comores' },
  { code: 'CG', en: 'Congo', fr: 'Congo' },
  { code: 'CD', en: 'Congo (Democratic Republic)', fr: 'Congo (République démocratique)' },
  { code: 'CR', en: 'Costa Rica', fr: 'Costa Rica' },
  { code: 'HR', en: 'Croatia', fr: 'Croatie' },
  { code: 'CU', en: 'Cuba', fr: 'Cuba' },
  { code: 'CY', en: 'Cyprus', fr: 'Chypre' },
  { code: 'CZ', en: 'Czechia', fr: 'Tchéquie' },
  { code: 'DK', en: 'Denmark', fr: 'Danemark' },
  { code: 'DJ', en: 'Djibouti', fr: 'Djibouti' },
  { code: 'DM', en: 'Dominica', fr: 'Dominique' },
  { code: 'DO', en: 'Dominican Republic', fr: 'République dominicaine' },
  { code: 'EC', en: 'Ecuador', fr: 'Équateur' },
  { code: 'EG', en: 'Egypt', fr: 'Égypte' },
  { code: 'SV', en: 'El Salvador', fr: 'Salvador' },
  { code: 'GQ', en: 'Equatorial Guinea', fr: 'Guinée équatoriale' },
  { code: 'ER', en: 'Eritrea', fr: 'Érythrée' },
  { code: 'EE', en: 'Estonia', fr: 'Estonie' },
  { code: 'SZ', en: 'Eswatini', fr: 'Eswatini' },
  { code: 'ET', en: 'Ethiopia', fr: 'Éthiopie' },
  { code: 'FI', en: 'Finland', fr: 'Finlande' },
  { code: 'FR', en: 'France', fr: 'France' },
  { code: 'GA', en: 'Gabon', fr: 'Gabon' },
  { code: 'GM', en: 'Gambia', fr: 'Gambie' },
  { code: 'GE', en: 'Georgia', fr: 'Géorgie' },
  { code: 'DE', en: 'Germany', fr: 'Allemagne' },
  { code: 'GH', en: 'Ghana', fr: 'Ghana' },
  { code: 'GR', en: 'Greece', fr: 'Grèce' },
  { code: 'GD', en: 'Grenada', fr: 'Grenade' },
  { code: 'GT', en: 'Guatemala', fr: 'Guatemala' },
  { code: 'GN', en: 'Guinea', fr: 'Guinée' },
  { code: 'GW', en: 'Guinea-Bissau', fr: 'Guinée-Bissau' },
  { code: 'GY', en: 'Guyana', fr: 'Guyana' },
  { code: 'HT', en: 'Haiti', fr: 'Haïti' },
  { code: 'HN', en: 'Honduras', fr: 'Honduras' },
  { code: 'HU', en: 'Hungary', fr: 'Hongrie' },
  { code: 'IS', en: 'Iceland', fr: 'Islande' },
  { code: 'IN', en: 'India', fr: 'Inde' },
  { code: 'ID', en: 'Indonesia', fr: 'Indonésie' },
  { code: 'IR', en: 'Iran', fr: 'Iran' },
  { code: 'IQ', en: 'Iraq', fr: 'Irak' },
  { code: 'IE', en: 'Ireland', fr: 'Irlande' },
  { code: 'IL', en: 'Israel', fr: 'Israël' },
  { code: 'IT', en: 'Italy', fr: 'Italie' },
  { code: 'JM', en: 'Jamaica', fr: 'Jamaïque' },
  { code: 'JP', en: 'Japan', fr: 'Japon' },
  { code: 'JO', en: 'Jordan', fr: 'Jordanie' },
  { code: 'KZ', en: 'Kazakhstan', fr: 'Kazakhstan' },
  { code: 'KE', en: 'Kenya', fr: 'Kenya' },
  { code: 'KI', en: 'Kiribati', fr: 'Kiribati' },
  { code: 'KP', en: 'North Korea', fr: 'Corée du Nord' },
  { code: 'KR', en: 'South Korea', fr: 'Corée du Sud' },
  { code: 'KW', en: 'Kuwait', fr: 'Koweït' },
  { code: 'KG', en: 'Kyrgyzstan', fr: 'Kirghizistan' },
  { code: 'LA', en: 'Laos', fr: 'Laos' },
  { code: 'LV', en: 'Latvia', fr: 'Lettonie' },
  { code: 'LB', en: 'Lebanon', fr: 'Liban' },
  { code: 'LS', en: 'Lesotho', fr: 'Lesotho' },
  { code: 'LR', en: 'Liberia', fr: 'Liberia' },
  { code: 'LY', en: 'Libya', fr: 'Libye' },
  { code: 'LI', en: 'Liechtenstein', fr: 'Liechtenstein' },
  { code: 'LT', en: 'Lithuania', fr: 'Lituanie' },
  { code: 'LU', en: 'Luxembourg', fr: 'Luxembourg' },
  { code: 'MG', en: 'Madagascar', fr: 'Madagascar' },
  { code: 'MW', en: 'Malawi', fr: 'Malawi' },
  { code: 'MY', en: 'Malaysia', fr: 'Malaisie' },
  { code: 'MV', en: 'Maldives', fr: 'Maldives' },
  { code: 'ML', en: 'Mali', fr: 'Mali' },
  { code: 'MT', en: 'Malta', fr: 'Malte' },
  { code: 'MH', en: 'Marshall Islands', fr: 'Îles Marshall' },
  { code: 'MR', en: 'Mauritania', fr: 'Mauritanie' },
  { code: 'MU', en: 'Mauritius', fr: 'Maurice' },
  { code: 'MX', en: 'Mexico', fr: 'Mexique' },
  { code: 'MD', en: 'Moldova', fr: 'Moldavie' },
  { code: 'MC', en: 'Monaco', fr: 'Monaco' },
  { code: 'MN', en: 'Mongolia', fr: 'Mongolie' },
  { code: 'ME', en: 'Montenegro', fr: 'Monténégro' },
  { code: 'MA', en: 'Morocco', fr: 'Maroc' },
  { code: 'MZ', en: 'Mozambique', fr: 'Mozambique' },
  { code: 'MM', en: 'Myanmar', fr: 'Myanmar' },
  { code: 'NA', en: 'Namibia', fr: 'Namibie' },
  { code: 'NP', en: 'Nepal', fr: 'Népal' },
  { code: 'NL', en: 'Netherlands', fr: 'Pays-Bas' },
  { code: 'NZ', en: 'New Zealand', fr: 'Nouvelle-Zélande' },
  { code: 'NI', en: 'Nicaragua', fr: 'Nicaragua' },
  { code: 'NE', en: 'Niger', fr: 'Niger' },
  { code: 'NG', en: 'Nigeria', fr: 'Nigéria' },
  { code: 'MK', en: 'North Macedonia', fr: 'Macédoine du Nord' },
  { code: 'NO', en: 'Norway', fr: 'Norvège' },
  { code: 'OM', en: 'Oman', fr: 'Oman' },
  { code: 'PK', en: 'Pakistan', fr: 'Pakistan' },
  { code: 'PS', en: 'Palestine', fr: 'Palestine' },
  { code: 'PA', en: 'Panama', fr: 'Panama' },
  { code: 'PG', en: 'Papua New Guinea', fr: 'Papouasie-Nouvelle-Guinée' },
  { code: 'PY', en: 'Paraguay', fr: 'Paraguay' },
  { code: 'PE', en: 'Peru', fr: 'Pérou' },
  { code: 'PH', en: 'Philippines', fr: 'Philippines' },
  { code: 'PL', en: 'Poland', fr: 'Pologne' },
  { code: 'PT', en: 'Portugal', fr: 'Portugal' },
  { code: 'QA', en: 'Qatar', fr: 'Qatar' },
  { code: 'RO', en: 'Romania', fr: 'Roumanie' },
  { code: 'RU', en: 'Russia', fr: 'Russie' },
  { code: 'RW', en: 'Rwanda', fr: 'Rwanda' },
  { code: 'SA', en: 'Saudi Arabia', fr: 'Arabie saoudite' },
  { code: 'SN', en: 'Senegal', fr: 'Sénégal' },
  { code: 'RS', en: 'Serbia', fr: 'Serbie' },
  { code: 'SC', en: 'Seychelles', fr: 'Seychelles' },
  { code: 'SL', en: 'Sierra Leone', fr: 'Sierra Leone' },
  { code: 'SG', en: 'Singapore', fr: 'Singapour' },
  { code: 'SK', en: 'Slovakia', fr: 'Slovaquie' },
  { code: 'SI', en: 'Slovenia', fr: 'Slovénie' },
  { code: 'SO', en: 'Somalia', fr: 'Somalie' },
  { code: 'ZA', en: 'South Africa', fr: 'Afrique du Sud' },
  { code: 'SS', en: 'South Sudan', fr: 'Soudan du Sud' },
  { code: 'ES', en: 'Spain', fr: 'Espagne' },
  { code: 'LK', en: 'Sri Lanka', fr: 'Sri Lanka' },
  { code: 'SD', en: 'Sudan', fr: 'Soudan' },
  { code: 'SR', en: 'Suriname', fr: 'Suriname' },
  { code: 'SE', en: 'Sweden', fr: 'Suède' },
  { code: 'CH', en: 'Switzerland', fr: 'Suisse' },
  { code: 'SY', en: 'Syria', fr: 'Syrie' },
  { code: 'TW', en: 'Taiwan', fr: 'Taïwan' },
  { code: 'TJ', en: 'Tajikistan', fr: 'Tadjikistan' },
  { code: 'TZ', en: 'Tanzania', fr: 'Tanzanie' },
  { code: 'TH', en: 'Thailand', fr: 'Thaïlande' },
  { code: 'TL', en: 'Timor-Leste', fr: 'Timor-Leste' },
  { code: 'TG', en: 'Togo', fr: 'Togo' },
  { code: 'TO', en: 'Tonga', fr: 'Tonga' },
  { code: 'TT', en: 'Trinidad and Tobago', fr: 'Trinité-et-Tobago' },
  { code: 'TN', en: 'Tunisia', fr: 'Tunisie' },
  { code: 'TR', en: 'Türkiye', fr: 'Turquie' },
  { code: 'TM', en: 'Turkmenistan', fr: 'Turkménistan' },
  { code: 'UG', en: 'Uganda', fr: 'Ouganda' },
  { code: 'UA', en: 'Ukraine', fr: 'Ukraine' },
  { code: 'AE', en: 'United Arab Emirates', fr: 'Émirats arabes unis' },
  { code: 'GB', en: 'United Kingdom', fr: 'Royaume-Uni' },
  { code: 'UY', en: 'Uruguay', fr: 'Uruguay' },
  { code: 'UZ', en: 'Uzbekistan', fr: 'Ouzbékistan' },
  { code: 'VU', en: 'Vanuatu', fr: 'Vanuatu' },
  { code: 'VE', en: 'Venezuela', fr: 'Venezuela' },
  { code: 'VN', en: 'Vietnam', fr: 'Vietnam' },
  { code: 'YE', en: 'Yemen', fr: 'Yémen' },
  { code: 'ZM', en: 'Zambia', fr: 'Zambie' },
  { code: 'ZW', en: 'Zimbabwe', fr: 'Zimbabwe' },
];

export const canadianProvinces = [
  { code: 'AB', en: 'Alberta', fr: 'Alberta' },
  { code: 'BC', en: 'British Columbia', fr: 'Colombie-Britannique' },
  { code: 'PE', en: 'Prince Edward Island', fr: 'Île-du-Prince-Édouard' },
  { code: 'MB', en: 'Manitoba', fr: 'Manitoba' },
  { code: 'NB', en: 'New Brunswick', fr: 'Nouveau-Brunswick' },
  { code: 'NS', en: 'Nova Scotia', fr: 'Nouvelle-Écosse' },
  { code: 'ON', en: 'Ontario', fr: 'Ontario' },
  { code: 'QC', en: 'Quebec', fr: 'Québec' },
  { code: 'SK', en: 'Saskatchewan', fr: 'Saskatchewan' },
  { code: 'NL', en: 'Newfoundland and Labrador', fr: 'Terre-Neuve-et-Labrador' },
  { code: 'NT', en: 'Northwest Territories', fr: 'Territoires du Nord-Ouest' },
  { code: 'NU', en: 'Nunavut', fr: 'Nunavut' },
  { code: 'YT', en: 'Yukon', fr: 'Yukon' },
];

export const USAStates = [
  { code: 'AL', en: 'Alabama', fr: 'Alabama' },
  { code: 'AK', en: 'Alaska', fr: 'Alaska' },
  { code: 'AZ', en: 'Arizona', fr: 'Arizona' },
  { code: 'AR', en: 'Arkansas', fr: 'Arkansas' },
  { code: 'CA', en: 'California', fr: 'Californie' },
  { code: 'CO', en: 'Colorado', fr: 'Colorado' },
  { code: 'CT', en: 'Connecticut', fr: 'Connecticut' },
  { code: 'DE', en: 'Delaware', fr: 'Delaware' },
  { code: 'FL', en: 'Florida', fr: 'Floride' },
  { code: 'GA', en: 'Georgia', fr: 'Géorgie' },
  { code: 'HI', en: 'Hawaii', fr: 'Hawaï' },
  { code: 'ID', en: 'Idaho', fr: 'Idaho' },
  { code: 'IL', en: 'Illinois', fr: 'Illinois' },
  { code: 'IN', en: 'Indiana', fr: 'Indiana' },
  { code: 'IA', en: 'Iowa', fr: 'Iowa' },
  { code: 'KS', en: 'Kansas', fr: 'Kansas' },
  { code: 'KY', en: 'Kentucky', fr: 'Kentucky' },
  { code: 'LA', en: 'Louisiana', fr: 'Louisiane' },
  { code: 'ME', en: 'Maine', fr: 'Maine' },
  { code: 'MD', en: 'Maryland', fr: 'Maryland' },
  { code: 'MA', en: 'Massachusetts', fr: 'Massachusetts' },
  { code: 'MI', en: 'Michigan', fr: 'Michigan' },
  { code: 'MN', en: 'Minnesota', fr: 'Minnesota' },
  { code: 'MS', en: 'Mississippi', fr: 'Mississippi' },
  { code: 'MO', en: 'Missouri', fr: 'Missouri' },
  { code: 'MT', en: 'Montana', fr: 'Montana' },
  { code: 'NE', en: 'Nebraska', fr: 'Nebraska' },
  { code: 'NV', en: 'Nevada', fr: 'Nevada' },
  { code: 'NH', en: 'New Hampshire', fr: 'New Hampshire' },
  { code: 'NJ', en: 'New Jersey', fr: 'New Jersey' },
  { code: 'NM', en: 'New Mexico', fr: 'Nouveau-Mexique' },
  { code: 'NY', en: 'New York', fr: 'État de New York' },
  { code: 'NC', en: 'North Carolina', fr: 'Caroline du Nord' },
  { code: 'ND', en: 'North Dakota', fr: 'Dakota du Nord' },
  { code: 'OH', en: 'Ohio', fr: 'Ohio' },
  { code: 'OK', en: 'Oklahoma', fr: 'Oklahoma' },
  { code: 'OR', en: 'Oregon', fr: 'Oregon' },
  { code: 'PA', en: 'Pennsylvania', fr: 'Pennsylvanie' },
  { code: 'RI', en: 'Rhode Island', fr: 'Rhode Island' },
  { code: 'SC', en: 'South Carolina', fr: 'Caroline du Sud' },
  { code: 'SD', en: 'South Dakota', fr: 'Dakota du Sud' },
  { code: 'TN', en: 'Tennessee', fr: 'Tennessee' },
  { code: 'TX', en: 'Texas', fr: 'Texas' },
  { code: 'UT', en: 'Utah', fr: 'Utah' },
  { code: 'VT', en: 'Vermont', fr: 'Vermont' },
  { code: 'VA', en: 'Virginia', fr: 'Virginie' },
  { code: 'WA', en: 'Washington', fr: 'Washington' },
  { code: 'WV', en: 'West Virginia', fr: 'Virginie-Occidentale' },
  { code: 'WI', en: 'Wisconsin', fr: 'Wisconsin' },
  { code: 'WY', en: 'Wyoming', fr: 'Wyoming' },
];
